import { HttpMethods, APIContexts } from 'enums';
import axios from 'axios';
import { apiRequestHandler, apiHost } from '.';

const apiContext = `${APIContexts.INTERSTITIAL}/`;

export const GetInterstitialsAPI = ({
  queryParams,
  requestBody,
  onSuccess,
  ...rest
}) => {
  const api = '';
  const endpoint = `${apiHost}${apiContext}${api}${queryParams.channelId}/interstitialtitleslist`;
  apiRequestHandler({
    endpoint,
    method: HttpMethods.POST,
    payload: requestBody,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};

export const GetIncludedInterstitialsAPI = ({
  queryParams,
  onSuccess,
  ...rest
}) => {
  const api = '';
  const endpoint = `${apiHost}${apiContext}${api}${queryParams.channelId}/includedinterstitiallist`;
  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};

export const GetInterstitialDetailAPI = ({
  queryParams,
  onSuccess,
  ...rest
}) => {
  const api = 'GetInterstitialDetail';
  const endpoint = `${apiHost}${apiContext}${api}/${queryParams.id}`;
  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};

export const GetInterstitialByExternalIDAPI = ({
  externalId,
  channelId,
  onSuccess,
  ...rest
}) => {
  const endpoint = `${apiHost}${apiContext}${externalId}?channelId=${channelId}`;
  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};

export const DeleteInterstitialAPI = ({
  id,
  force = false,
  onSuccess,
  ...rest
}) => {
  const endpoint = `${apiHost}${apiContext}${id}?force=${force}`;

  apiRequestHandler({
    endpoint,
    method: HttpMethods.DELETE,
    onSuccess: (res) => onSuccess && onSuccess(res),
    ...rest,
  });
};
